import { createSelector } from 'reselect';
import { getOfferIdsByFilter } from './getOfferIdsByFilter';

export const getAvailableDepositPayCount = createSelector(getOfferIdsByFilter, (result) => result.depositPay?.length || 0);
